import React from "react";
import computer from "../img/computer-picture.jpg";
import { motion } from "framer-motion";
import { titleAnim, simpleContainer, photoAnimation } from "../animate";

const About = () => {
  return (
    <div className="about">
      <motion.div
        variants={simpleContainer}
        initial="hidden"
        animate="show"
        className="description"
      >
        <div className="hide">
          <motion.h3 variants={titleAnim}>
            分析<span>演算法</span>邏輯
          </motion.h3>
        </div>
        <div className="hide">
          <motion.h3 variants={titleAnim}>深入了解語言觀念</motion.h3>
        </div>
        <div className="hide">
          <motion.h2 variants={titleAnim}>
            動手<span>學習寫程式</span>
          </motion.h2>
        </div>

        <p>
          我相信，透過清晰的講解與分析，每個人都能掌握程式設計與開發。我透過Udemy線上課程，實現我的信念。
        </p>

        <a href="#coursePart">
          <motion.button
            whileTap={{
              scale: 0.8,
            }}
            onClick={() => {
              document.querySelector("html").style.scrollBehavior = "smooth";
              window.setTimeout(() => {
                document.querySelector("html").style.scrollBehavior = "auto";
              }, 20);
            }}
          >
            了解課程
          </motion.button>
        </a>
      </motion.div>

      <motion.div
        variants={photoAnimation}
        initial="hidden"
        animate="show"
        className="image"
      >
        <img src={computer} alt="" />
      </motion.div>
    </div>
  );
};

export default About;
